<template>
  <!-- Component Start -->
  <div class="bg-white mb-12 md:my-12" v-if="faqData.length > 0">
    <NuxtLayout name="center">
      <div class="flex md:flex-row flex-col">
        <div class="basis-[35%] md:mr-4">
          <h2 class="text-left my-8 text-[27px]" v-if="showQuestion">
            {{ $t("faqBlock.title") }}
          </h2>
          <div
            class="space-y-4 text-space-cadet leading-7"
            :class="{ 'mt-4': !showQuestion }"
          >
            <p>
              {{ $t("faqBlock.introLine1") }}
              <NuxtLinkLocale
                :locale="switchBlogLocale()"
                to="/faqs"
                class="text-secondary underline"
              >
                {{ $t("faqBlock.FAQSection") }}
              </NuxtLinkLocale>
            </p>
            <p>{{ $t("faqBlock.introLine2") }}</p>

            <CommonCallNumber
              tag="div"
              callClass="text-secondary underline"
              keyPath="phoneCall.faqBlock.title"
            ></CommonCallNumber>
            <!-- 
            <div>
              Call us on
              <NuxtLinkLocale :locale="switchBlogLocale()"
                :to="
                  'tel:' +
                  globalStore.sitePrimaryPhoneNumber.call_to_action_number
                "
                class="text-secondary underline"
              >
                {{ globalStore.sitePrimaryPhoneNumber.display_number }}
              </NuxtLinkLocale>
            </div> -->
            <div>
              <NuxtLink
                @click="useShowChatWidget"
                class="text-secondary underline cursor-pointer"
              >
                <div class="flex">
                  {{ $t("common.openLiveChat") }}
                  <NuxtImg
                    loading="lazy"
                    src="/icons/arrow-right-secondary.svg"
                    class="mx-1"
                    alt="right arrow"
                    width="9"
                    height="28"
                  />
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
        <div
          class="basis-[65%] lg:mx-12 md:ml-12 flex flex-col items-start clinicDetailContent order-1 md:order-2"
        >
          <CommonAccordian
            class="w-full"
            :class="{ 'md:my-20 my-4': showQuestion }"
            :dataLists="faqData"
          ></CommonAccordian>
        </div>
      </div>
    </NuxtLayout>
  </div>
  <!-- Component End  -->
</template>

<script setup>
import { useGlobalStore } from "@/stores/global";
import { useShowChatWidget } from "@/utils/useTawkMessenger";
const { t } = useI18n();
const globalStore = useGlobalStore();
defineProps({
  faqData: Array,
  showQuestion: {
    type: Boolean,
    default: false,
  },
});
</script>

<style></style>
